import { useContext, useEffect, useRef } from "react";
import { requestErrorDisplay as displayError } from "../utils";
import { TenderTimeContext } from "../context/TenderTimeContext";

export const useTenderActionError = (order, { onRefreshOrder } = {}) => {
  const scope = useContext(TenderTimeContext);
  const orderId = order?.id;
  const deadline = order?.tenderDateEnd;
  const identity = useRef(null);
  if (
    !identity.current ||
    identity.current.orderId !== orderId ||
    identity.current.deadline !== deadline ||
    identity.current.scopeToken !== scope?.token
  ) {
    identity.current = { orderId, deadline, scopeToken: scope?.token };
  }
  const token = identity.current;
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const requestErrorDisplay = async (error, t, fallback) => {
    displayError(error, t, fallback);
    const status = error?.response?.status ?? error?.httpStatus;
    if (
      error?.__CANCEL__ ||
      status !== 409 ||
      orderId == null ||
      !onRefreshOrder ||
      !mounted.current ||
      identity.current !== token ||
      (scope && !scope.isCurrent())
    ) {
      return;
    }
    try {
      // Use the card's loader so its state actually receives the fresh order.
      // A conflict is not a successful bid: never call the form's onSuccess handler.
      await onRefreshOrder({ silent: true });
      if (scope?.isCurrent()) await scope.refreshTime();
    } catch {
      // Keep the original endpoint error; do not retry the bid or discard its draft.
    }
  };

  return { requestErrorDisplay };
};
